import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { Type } from '../models/type.model';

@Injectable({ providedIn: 'root' })
export class TypesService {
  http = inject(HttpClient);

  getList(): Observable<Type[]> {
    return this.http.get<Type[]>('commonTypes');
  }

  organizeTypesByGroup(types: Type[]): { [key: string]: Type[] } {
    const groupedTypes: { [key: string]: Type[] } = {};
    types.forEach((type) => {
      if (!groupedTypes[type.group]) {
        groupedTypes[type.group] = [];
      }
      groupedTypes[type.group].push(type);
    });
    return groupedTypes;
  }
}
